import { styled } from '@mui/material/styles';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableCell from '@mui/material/TableCell';

export const StyledTableSortLabel = styled(TableSortLabel)({
  svg: {
    width: '12px',
    height: '12px'
  }
});

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'centered'
})(({ centered }) => ({
  textAlign: centered ? 'center' : 'left'
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTableHeader/styles.js